import React, { FC } from "react"
import { Link } from "react-router-dom"

type Props = {
  modalId: string
  title: string
  desc: string
  confirmationBtnText: string
  cancelBtnText: string
  onConfirm: (e: React.MouseEvent) => void
}

const DeleteModal: FC<Props> = props => {
  const {
    title,
    desc,
    confirmationBtnText,
    cancelBtnText,
    modalId,
    onConfirm,
  } = props

  return (
    <div className="modal fade" id={modalId}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <form>
            <div className="modal-body text-center">
              <span className="delete-icon">
                <i className="ti ti-trash-x" />
              </span>
              <h4>{title}</h4>
              <p>{desc}</p>
              <div className="d-flex justify-content-center">
                <Link
                  to="#"
                  className="btn btn-light me-3"
                  data-bs-dismiss="modal"
                >
                  {cancelBtnText}
                </Link>
                <Link
                  to="#"
                  className="btn btn-danger"
                  data-bs-dismiss="modal"
                  onClick={onConfirm}
                >
                  {confirmationBtnText}
                </Link>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default DeleteModal
